import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Constants } from '../../lib/const/constants';
import { useNavigate } from 'react-router-dom';
import { getCountryInfo } from '../../lib/currenyUtils';

const CURRENCY_SYMBOLS = {
  INR: '₹',
  GBP: '£',
  EUR: '€',
  USD: '$',
  AED: 'د.إ',
  CAD: '$',
  AUD: '$',
  SGD: '$',
  HKD: '$',
  JPY: '¥',
  CNY: '¥',
  CHF: '₣',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  ZAR: 'R',
  MXN: '$',
  BRL: 'R$',
  TRY: '₺',
  RUB: '₽',
  KWD: 'د.ك',
  SAR: '﷼',
  QAR: '﷼',
  BHD: '.د.ب',
  OMR: '﷼',
  NZD: '$',
  THB: '฿',
  MYR: 'RM',
  IDR: 'Rp',
  PHP: '₱',
  VND: '₫',
  PKR: '₨',
  LKR: '₨',
  BDT: '৳',
  NGN: '₦',
  KES: 'KSh',
  GHS: '₵',
  UGX: 'USh',
  TZS: 'TSh',
  ETB: 'Br',
  XOF: 'CFA',
  XAF: 'CFA',
  MAD: 'د.م.',
  EGP: 'E£',
  DZD: 'دج',
  TND: 'د.ت',
  ILS: '₪',
  JOD: 'JD',
  LBP: 'ل.ل',
  UAH: '₴',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  BGN: 'лв',
  HRK: 'kn',
  RSD: 'дин',
  ISK: 'kr',
  CLP: '$',
  COP: '$',
  PEN: 'S/',
  ARS: '$',
  UYU: '$U',
  BOB: 'Bs.',
};

const CURRENCY_AVATAR_COLORS = {
  INR: { bg: '#E897001A', color: '#D26521' },
  GBP: { bg: '#EDE7F6', color: '#4527A0' },
  EUR: { bg: '#E3F2FD', color: '#1565C0' },
  USD: { bg: '#E8F5E9', color: '#2E7D32' },
  AED: { bg: '#E0F7FA', color: '#006064' },
  CAD: { bg: '#FCE4EC', color: '#880E4F' },
  AUD: { bg: '#FFF8E1', color: '#F57F17' },
  SGD: { bg: '#F3E5F5', color: '#6A1B9A' },
  HKD: { bg: '#FFEBEE', color: '#B71C1C' },
  JPY: { bg: '#FBE9E7', color: '#BF360C' },
  CNY: { bg: '#FFEBEE', color: '#C62828' },
  CHF: { bg: '#ECEFF1', color: '#37474F' },
  DEFAULT: { bg: '#F0F4FF', color: '#0B214E' },
};

const getAvatarStyle = (currencyCode) =>
  CURRENCY_AVATAR_COLORS[currencyCode] || CURRENCY_AVATAR_COLORS.DEFAULT;

const resolveCurrencyCode = (beneficiary) => {
  if (beneficiary.currency) return beneficiary.currency.toUpperCase();
  const fromCountry = Constants.CURRENCYID?.[beneficiary.country_id];
  if (fromCountry) return fromCountry.toUpperCase();
  return null;
};

function Beneficiary({
  beneficiaryList,
  sendDataToParent,
  pay = false,
  currency_type,
  balance,
  SendMoneyFlowCurrency,
  Nav_node,
  amount,
  currencyid,
}) {
  const navigate = useNavigate();
  console.log('Nav_node', Nav_node);
  const [accountNumber, setAccountNumber] = useState('');
  const [sortcode, setSortcode] = useState('');
  const [accountNumber1, setAccountNumber1] = useState('');
  const [sortcode1, setSortcode1] = useState('');
  const [selectedId, setSelectedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 5;

  const workspaces = JSON.parse(sessionStorage.getItem('login_workspaces'));
  const account_type = workspaces?.[0]?.type;
  console.log(account_type);

  const passdata = async (
    display_name,
    code,
    bank_account_number,
    type,
    beneficiaryid,
    country,
    address,
    bank_account_id,
    country_id,
    bene_type,
    bank_type,
    currency,
    payment_type,
    meta,
  ) => {
    console.log('129');

    console.log(
      display_name,
      code,
      bank_account_number,
      type,
      beneficiaryid,
      country,
      bank_account_id,
      country_id,
      bene_type,
      bank_type,
      currency,
      payment_type,
    );

    sendDataToParent(
      display_name,
      code,
      bank_account_number,
      type,
      beneficiaryid,
      country,
      address,
      bank_account_id,
      country_id,
      bene_type,
      bank_type,
      currency,
      payment_type,
      meta,
    );
  };

  useEffect(() => {
    getData();
  });

  const getData = async () => {
    const workspace = sessionStorage.getItem('login_workspaces');
    if (workspace) {
      const defaultBank = sessionStorage.getItem('defaultBank');
      const parsedWorkspace = JSON.parse(workspace);
      if (defaultBank === 'Clear Bank as Service') {
        setAccountNumber(
          sessionStorage.getItem('clearBankCustomerWalletNumber'),
        );
        setSortcode(sessionStorage.getItem('clearBankCustomerSortCode'));
      }
      if (parsedWorkspace[0].accounts.length > 0) {
        setAccountNumber1(parsedWorkspace[0].accounts.meta.account_number);
        setSortcode1(parsedWorkspace[0].accounts.meta.routing_code);
      }
    }
    console.log(accountNumber, sortcode, accountNumber1, sortcode1);
    console.log('beneficiaryList', beneficiaryList);
  };

  const getInitials = (name = '') => name.trim().charAt(0).toUpperCase();

  const toTitleCase = (str = '') =>
    str
      .toLowerCase()
      .split(' ')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

  const PaginationControls = ({ totalPages }) => {
    const getPages = () => {
      if (totalPages <= 3)
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      if (currentPage === 1) return [1, 2, 3];
      if (currentPage === totalPages)
        return [totalPages - 2, totalPages - 1, totalPages];
      return [currentPage - 1, currentPage, currentPage + 1];
    };

    const pages = getPages();

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 6,
          padding: '12px 24px',
          borderTop: '1px solid #F2F4F7',
        }}
      >
        <button
          onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          disabled={currentPage === 1}
          style={{
            width: 32,
            height: 32,
            borderRadius: 6,
            border: '1px solid #E6E5E5',
            background: '#FFFFFF',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            opacity: currentPage === 1 ? 0.4 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18l-6-6 6-6"
              stroke="#1D2338"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {pages[0] > 1 && (
          <>
            <button
              onClick={() => setCurrentPage(1)}
              style={{
                width: 32,
                height: 32,
                borderRadius: 6,
                border: '1px solid #E6E5E5',
                background: '#FFFFFF',
                color: '#1D2338',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              1
            </button>
            {pages[0] > 2 && (
              <span style={{ fontSize: 13, color: '#9CA3AF' }}>...</span>
            )}
          </>
        )}

        {pages.map((page) => (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            style={{
              width: 32,
              height: 32,
              borderRadius: 6,
              border: '1px solid',
              borderColor: currentPage === page ? '#0B214E' : '#E6E5E5',
              background: currentPage === page ? '#0B214E' : '#FFFFFF',
              color: currentPage === page ? '#FFFFFF' : '#1D2338',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {page}
          </button>
        ))}

        {pages[pages.length - 1] < totalPages && (
          <>
            {pages[pages.length - 1] < totalPages - 1 && (
              <span style={{ fontSize: 13, color: '#9CA3AF' }}>...</span>
            )}
            <button
              onClick={() => setCurrentPage(totalPages)}
              style={{
                width: 32,
                height: 32,
                borderRadius: 6,
                border: '1px solid #E6E5E5',
                background: '#FFFFFF',
                color: '#1D2338',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
          disabled={currentPage === totalPages}
          style={{
            width: 32,
            height: 32,
            borderRadius: 6,
            border: '1px solid #E6E5E5',
            background: '#FFFFFF',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
            opacity: currentPage === totalPages ? 0.4 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 18l6-6-6-6"
              stroke="#1D2338"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  };
  PaginationControls.propTypes = { totalPages: PropTypes.number };

  if (pay) {
    const totalPages = Math.ceil((beneficiaryList || []).length / PAGE_SIZE);
    const visibleList = (beneficiaryList || []).slice(
      (currentPage - 1) * PAGE_SIZE,
      currentPage * PAGE_SIZE,
    );

    console.log('visibleList', visibleList);

    return (
      <div>
        {(beneficiaryList || []).length === 0 ? (
          <div
            style={{
              padding: '2rem',
              textAlign: 'center',
              color: '#9CA3AF',
              fontSize: 14,
            }}
          >
            No Data Available
          </div>
        ) : (
          <>
            <div
              style={{ height: '1px', background: '#F2F4F7', marginBottom: 0 }}
            />

            {visibleList.map((beneficiary, index) => {
              if (!beneficiary.id) return null;

              const currencyCode = resolveCurrencyCode(beneficiary);
              const symbol = currencyCode
                ? CURRENCY_SYMBOLS[currencyCode] || currencyCode
                : null;
              const avatarColors = getAvatarStyle(currencyCode);

              const typeLabel =
                beneficiary.bene_type === 'corporate' ||
                beneficiary.bene_type === 'company'
                  ? 'Business'
                  : toTitleCase(beneficiary.bene_type || 'Individual');

              return (
                <div key={beneficiary.id}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      width: '960px',
                      minHeight: '120px',
                      height: 'auto',
                      padding: '24px',
                      background: '#FFFFFF',
                      borderBottom:
                        index < visibleList.length - 1
                          ? '1px solid #E6E5E5'
                          : 'none',
                      opacity: 1,
                      gap: '16px',
                      transition: 'background 0.12s',
                      boxSizing: 'border-box',
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = '#F9FAFB')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = 'transparent')
                    }
                  >
                    {/* Avatar */}
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 8,
                        background: avatarColors.bg,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        fontSize: symbol && symbol.length > 1 ? 13 : 18,
                        fontWeight: 700,
                        color: avatarColors.color,
                        border: `1px solid ${avatarColors.bg}`,
                        overflow: 'hidden',
                        marginTop: 2,
                      }}
                    >
                      {getInitials(beneficiary.display_name)}
                    </div>

                    {/* Main info */}
                    <div
                      style={{
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      {/* Name + flag */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          marginBottom: 4,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 16,
                            fontWeight: 600,
                            color: '#1D2338',
                            lineHeight: '140%',
                            letterSpacing: '0px',
                          }}
                        >
                          {toTitleCase(beneficiary.display_name)}
                        </span>

                        {currencyCode &&
                          (() => {
                            const flagInfo = getCountryInfo(currencyCode);
                            if (!flagInfo?.flag) return null;

                            return (
                              <span
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  flexShrink: 0,
                                  zoom: 0.6,
                                  lineHeight: 1,
                                }}
                              >
                                {flagInfo.flag}
                              </span>
                            );
                          })()}
                      </div>

                      {/* Account Number / IBAN */}
                      <div
                        style={{
                          marginBottom: 6,
                          fontSize: 12,
                          color: '#676F7D',
                          fontWeight: '400',
                          lineHeight: '140%',
                          letterSpacing: '0px',
                        }}
                      >
                        Account Number/ IBAN :{' '}
                        <span
                          style={{
                            fontWeight: 400,
                            color: '#1D2338',
                            fontSize: 12,
                            lineHeight: '140%',
                            letterSpacing: '0px',
                          }}
                        >
                          {beneficiary.bank_account_number || '—'}
                        </span>
                        {beneficiary.code && (
                          <>
                            <span style={{ color: '#676F7D', margin: '0 6px' }}>
                              |
                            </span>
                            <span style={{ color: '#676F7D', fontSize: 12 }}>
                              {beneficiary.country === 'GB' && currencyCode === 'GBP' ? 'Sort Code : ':'Code : '}
                            </span>
                            <span
                              style={{
                                fontWeight: 400,
                                color: '#1D2338',
                                fontSize: 12,
                                lineHeight: '140%',
                                letterSpacing: '0px',
                              }}
                            >
                              {beneficiary.code
                                ? beneficiary.country?.toUpperCase() === 'GB' &&
                                  currencyCode === 'GBP'
                                  ? beneficiary.code
                                      .replace(/\D/g, '')
                                      .replace(
                                        /(\d{2})(\d{2})(\d{2})/,
                                        '$1-$2-$3',
                                      )
                                  : beneficiary.code
                                : ''}
                            </span>
                          </>
                        )}
                      </div>

                      {/* Tags */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 8,
                          flexWrap: 'wrap',
                        }}
                      >
                        <span style={tagStyle}>
                          ID:{' '}
                          <strong style={tagValueStyle}>
                            {beneficiary.id}
                          </strong>
                        </span>
                        <span style={tagStyle}>
                          Account Type:{' '}
                          <strong style={tagValueStyle}>{typeLabel}</strong>
                        </span>

                        {currencyCode && (
                          <span style={tagStyle}>
                            Currency:{' '}
                            <strong style={tagValueStyle}>
                              {currencyCode}
                            </strong>
                          </span>
                        )}
                        {beneficiary.meta?.payment_type && (
                          <span style={tagStyle}>
                            Payment Type:{' '}
                            <strong style={tagValueStyle}>
                              {toTitleCase(beneficiary.meta.payment_type)}
                            </strong>
                          </span>
                        )}
                        {beneficiary.country && (
                          <span style={{ ...tagStyle, maxWidth: '100%' }}>
                            Country:{' '}
                            <strong
                              style={{
                                ...tagValueStyle,
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                              }}
                            >
                              {beneficiary.country}
                            </strong>
                          </span>
                        )}
                      </div>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        flexShrink: 0,
                        marginTop: 2,
                      }}
                    >
                      {pay && account_type === 'business' && (
                        <button
                          style={payBtnStyle}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = '#0a1f45')
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = '#0B214E')
                          }
                          onClick={() =>
                            passdata(
                              beneficiary.display_name,
                              beneficiary.code,
                              beneficiary.bank_account_number,
                              beneficiary.type,
                              beneficiary.id,
                              beneficiary.country,
                              beneficiary.address,
                              beneficiary.bank_account_id,
                              beneficiary.country_id,
                              beneficiary.bene_type,
                              beneficiary.bank_type,
                              beneficiary.currency,
                              beneficiary.payment_type,
                              beneficiary.meta,
                            )
                          }
                        >
                          Pay
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M6 10V2M6 2L2 6M6 2L10 6"
                              stroke="#FFFFFF"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      )}

                      <button
                        style={eyeBtnStyle}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.borderColor = '#0B214E')
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.borderColor = '#D0D5DD')
                        }
                        onClick={() =>
                          navigate('/beneficiary-detail', {
                            state: {
                              beneficiary,
                              currency_type,
                              country: beneficiary.country,
                              address: beneficiary.address,
                              balance,
                              SendMoneyFlowCurrency,
                              Nav_node,
                              amount,
                              currencyid,
                            },
                          })
                        }
                      >
                        <svg
                          width="15"
                          height="10"
                          viewBox="0 0 24 16"
                          fill="none"
                          style={{ display: 'block', opacity: 1 }}
                        >
                          <path
                            d="M1 8C1 8 5 1 12 1C19 1 23 8 23 8C23 8 19 15 12 15C5 15 1 8 1 8Z"
                            stroke="#676F7D"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <circle
                            cx="12"
                            cy="8"
                            r="3.5"
                            stroke="#676F7D"
                            strokeWidth="2"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}

            {totalPages > 1 && <PaginationControls totalPages={totalPages} />}
          </>
        )}
      </div>
    );
  }

  const filteredList = (
    Array.isArray(beneficiaryList) ? beneficiaryList : []
  ).filter((b) => {
    if (!searchTerm.trim()) return true;
    const q = searchTerm.toLowerCase();
    return (
      b.display_name?.toLowerCase().includes(q) ||
      b.bank_account_number?.toLowerCase().includes(q) ||
      b.code?.toLowerCase().includes(q)
    );
  });

  const nonPayTotalPages = Math.ceil(filteredList.length / PAGE_SIZE);
  const visibleList = filteredList.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE,
  );
  const hasMore = nonPayTotalPages > 1;

  return (
    <div style={styles.wrapper}>
      <div style={styles.searchRow}>
        <div style={styles.searchInputWrapper}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            style={styles.searchIcon}
          >
            <circle cx="11" cy="11" r="7" stroke="#9CA3AF" strokeWidth="2" />
            <path
              d="M16.5 16.5L21 21"
              stroke="#9CA3AF"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          <input
            type="text"
            placeholder="Search Beneficiary by name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>
      </div>

      <div style={styles.graySection}>
        <div style={styles.cardListWrap}>
          {filteredList.length > 0 && (
            <div style={styles.savedLabel}>
              Saved Beneficiaries ({filteredList.length})
            </div>
          )}

          <div style={{ position: 'relative' }}>
            <div style={styles.cardScroll}>
              {filteredList.length === 0 ? (
                <div style={styles.emptyMsg}>No Beneficiaries Found</div>
              ) : (
                visibleList.map((beneficiary, index) => {
                  if (!beneficiary.id) return null;
                  const isSelected = selectedId === beneficiary.id;
                  return (
                    <React.Fragment key={beneficiary.id}>
                      <div
                        style={{
                          ...styles.card,
                          boxSizing: 'border-box',
                          width: '100%',
                          padding: isSelected ? '8px 12px' : '16px 20px',
                        }}
                        onClick={() => {
                          setSelectedId(beneficiary.id);
                          passdata(
                            beneficiary.display_name,
                            beneficiary.code,
                            beneficiary.bank_account_number,
                            beneficiary.type,
                            beneficiary.id,
                            beneficiary.country,
                            beneficiary.address,
                            beneficiary.bank_account_id,
                            beneficiary.country_id,
                            beneficiary.bene_type,
                            beneficiary.bank_type,
                            beneficiary.currency,
                            beneficiary.payment_type,
                            beneficiary.meta,
                          );
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected)
                            e.currentTarget.style.background = '#FAFAFA';
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected)
                            e.currentTarget.style.background = '#FFFFFF';
                        }}
                      >
                        <div
                          style={
                            isSelected
                              ? styles.selectedInnerBox
                              : { display: 'contents' }
                          }
                        >
                          <div
                            style={{
                              ...styles.avatar,
                              backgroundColor: isSelected
                                ? '#306ACE'
                                : '#676F7D',
                              color: '#FFFFFF',
                            }}
                          >
                            {getInitials(beneficiary.display_name)}
                          </div>

                          <div style={styles.cardBody}>
                            <div style={styles.cardNameRow}>
                              <span style={styles.cardNameWrapper}>
                                <span
                                  style={styles.cardName}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate('/beneficiary-detail', {
                                      state: {
                                        beneficiary,
                                        currency_type,
                                        country: beneficiary.country,
                                        address: beneficiary.address,
                                        balance,
                                        SendMoneyFlowCurrency,
                                        Nav_node,
                                        amount,
                                        currencyid,
                                      },
                                    });
                                  }}
                                >
                                  {toTitleCase(beneficiary.display_name)}
                                </span>
                              </span>
                              {beneficiary.country && (
                                <span style={styles.cardCountry}>
                                  {' '}
                                  . {beneficiary.country}
                                </span>
                              )}
                            </div>
                            <div style={styles.cardMeta}>
                              {beneficiary.bank_account_number}

                              {beneficiary.code
                                ? ` . (${
                                    beneficiary.country?.toUpperCase() ===
                                      'GB' &&
                                    currency_type.toUpperCase() === 'GBP'
                                      ? beneficiary.code

                                          .replace(/\D/g, '')

                                          .replace(
                                            /(\d{2})(\d{2})(\d{2})/,

                                            '$1-$2-$3',
                                          )
                                      : beneficiary.code
                                  })`
                                : ''}
                            </div>
                          </div>
                          <div
                            style={{
                              ...styles.chevronWrap,
                              background: isSelected ? '#306ACE' : '#E6E5E5',
                            }}
                          >
                            <svg
                              width="5"
                              height="9"
                              viewBox="0 0 8 14"
                              fill="none"
                            >
                              <path
                                d="M1 1L7 7L1 13"
                                stroke={isSelected ? '#FFFFFF' : '#203358'}
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>

                      {index < visibleList.length - 1 && (
                        <div style={styles.divider} />
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </div>
          </div>

          {hasMore && <PaginationControls totalPages={nonPayTotalPages} />}
        </div>
      </div>
    </div>
  );
}

const tagStyle = {
  display: 'inline-flex',
  alignItems: 'flex-start',
  gap: 4,
  padding: '4px 8px',
  background: '#F6F6FB',
  borderRadius: 4,
  fontSize: '12px',
  fontWeight: '400',
  color: '#676F7D',
  lineHeight: '16.5px',
  flexWrap: 'wrap',
};

const tagValueStyle = {
  fontWeight: 500,
  color: '#1D2338',
  fontSize: '12px',
  lineHeight: '16.5px',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
};

const payBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '104px',
  height: '48px',
  borderRadius: '6px',
  gap: '6px',
  paddingTop: '8px',
  paddingRight: '12px',
  paddingBottom: '8px',
  paddingLeft: '12px',
  background: '#203358',
  border: '1px solid #C8CCDA',
  opacity: 1,
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '140%',
  letterSpacing: '0px',
  color: '#FFFFFF',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'background 0.15s',
  flexShrink: 0,
};

const eyeBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#FFFFFF',
  border: '1px solid #C8CCDA',
  borderRadius: 6,
  width: 48,
  height: 48,
  cursor: 'pointer',
  transition: 'border-color 0.15s',
  flexShrink: 0,
};

const styles = {
  wrapper: {
    width: '768px',
    gap: '24px',
  },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16,
    height: '56px',
    width: '768px',
  },
  searchInputWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    background: '#FFFFFF',
    border: '1px solid #C8CCDA',
    borderRadius: 10,
    padding: '0 16px',
    height: '56px',
    width: '638px',
    boxSizing: 'border-box',
  },
  searchIcon: {
    flexShrink: 0,
    height: '20px',
    width: '20px',
  },
  searchInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    fontWeight: '400',
    color: '#D7D7D7',
    background: 'transparent',
    letterSpacing: 0,
    lineHeight: '20px',
  },
  filterBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '16px',
    height: '56px',
    width: '118px',
    background: '#FFFFFF',
    border: '1px solid #C8CCDA',
    borderRadius: '8px',
    fontSize: 14,
    fontWeight: 600,
    color: '#1D2338',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    fontFamily: 'Inter, sans-serif',
    boxSizing: 'border-box',
  },
  graySection: {
    background: '#EEF2F8',
    borderRadius: 12,
    width: '768px',
    boxSizing: 'border-box',
    padding: '0px',
  },
  savedLabel: {
    fontSize: 14,
    fontWeight: 700,
    color: '#1D2338',
    lineHeight: '24px',
    padding: '16px 16px 12px 16px',
  },
  cardListWrap: {
    background: '#FFFFFF',
    borderRadius: 12,
    border: '1px solid #EBEBEB',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    width: '768px',
    boxSizing: 'border-box',
  },
  cardScroll: {
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: '16px 20px',
    cursor: 'pointer',
    transition: 'background 0.12s',
    boxSizing: 'border-box',
    width: '100%',
  },
  divider: {
    height: '1px',
    background: '#F2F2F2',
    margin: '0 20px',
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    fontWeight: 400,
    backgroundColor: '#676F7D',
    color: '#FFFFFF',
    flexShrink: 0,
  },
  cardBody: {
    flex: 1,
    minWidth: 0,
    gap: '6px',
  },
  cardNameRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 0,
    marginBottom: 3,
    flexWrap: 'wrap',
  },
  cardNameWrapper: {
    display: 'inline-block',
    paddingBottom: 1,
    paddingLeft: 2,
    paddingRight: 2,
  },
  cardName: {
    fontSize: 16,
    fontWeight: 700,
    color: '#203358',
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'inline',
    lineHeight: '100%',
  },
  cardCountry: {
    fontSize: 14,
    fontWeight: 500,
    color: '#777C92',
    lineHeight: '100%',
  },
  cardMeta: {
    fontSize: 12,
    fontWeight: 400,
    marginTop: 4,
    display: 'inline-block',
    padding: '0 6px',
    background: '#ECEFF6',
    color: '#1D2338',
    borderRadius: 4,
    // removed fixed height
  },
  chevronWrap: {
    flexShrink: 0,
    width: '36px',
    height: '36px',
    background: '#E6E5E5',
    borderRadius: '32px',
    gap: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyMsg: {
    padding: '2rem',
    textAlign: 'center',
    color: '#9CA3AF',
    fontSize: 14,
    fontFamily: 'Inter, sans-serif',
  },
  viewAllRow: {
    padding: '12px 20px',
    textAlign: 'right',
  },
  viewAllBtn: {
    background: 'none',
    border: 'none',
    fontSize: 14,
    fontWeight: 600,
    color: '#0B4FCE',
    cursor: 'pointer',
    padding: 0,
    fontFamily: 'Inter, sans-serif',
  },
  selectedInnerBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    width: '100%',
    padding: '12px 16px',
    border: '1.5px solid #1A54CF',
    borderRadius: 12,
    background: '#EBF0FA',
    boxSizing: 'border-box',
  },
};

Beneficiary.propTypes = {
  beneficiaryList: PropTypes.array,
  sendDataToParent: PropTypes.any,
  pay: PropTypes.bool,
  currency_type: PropTypes.any,
  balance: PropTypes.any,
  SendMoneyFlowCurrency: PropTypes.any,
  Nav_node: PropTypes.any,
  amount: PropTypes.any,
  currencyid: PropTypes.any,
};

export default Beneficiary;
